module.exports = __webpack_public_path__ + "static/media/axegpromouse-4.b7eafe60.jpg";